// The open-level readiness check on a Succeedo link page (Phase 5, PRD
// §5-2): six questions, one per area, scored in the browser. It gives a
// stage and the weak spots, never a dollar figure, and nothing is saved.
// Figures need an account (the full readiness check and valuation).

export const ANSWERS = [
  { value: 2, label: 'Yes' },
  { value: 1, label: 'Partly' },
  { value: 0, label: 'Not yet' },
];

export const QUESTIONS = [
  { key: 'financial', area: 'Financial records', text: 'Are your financial statements clean, current and reviewed by an accountant?' },
  { key: 'human', area: 'Running without you', text: 'Could the business run well for three months without you?' },
  { key: 'customer', area: 'Customer base', text: 'Is no single customer more than 15% of your revenue?' },
  { key: 'structural', area: 'Agreements', text: 'Are your buy-sell and company agreements written down and up to date?' },
  { key: 'wealth', area: 'Your own plan', text: 'Do you know how much you need from the sale to live the life you want after it?' },
  { key: 'timeline', area: 'Timeline', text: 'Have you decided roughly when you want to step back?' },
];

export const STAGES = [
  { min: 10, key: 'harvest', label: 'Ready to plan your exit', text: 'The basics are in place. The next step is choosing how and when to exit, and what the business is worth.' },
  { min: 6, key: 'build', label: 'Building value', text: 'You have a foundation. Closing a few gaps now is what raises the price and widens your options later.' },
  { min: 0, key: 'protect', label: 'Protecting what you have', text: 'Most owners start here. A handful of fixes protect the value you have built and make everything after easier.' },
];

// answers: { [key]: 0 | 1 | 2 }. Returns null until every question has an answer.
export function scoreQuickCheck(answers) {
  if (QUESTIONS.some((q) => answers[q.key] === undefined)) return null;
  const total = QUESTIONS.reduce((sum, q) => sum + answers[q.key], 0);
  const stage = STAGES.find((s) => total >= s.min);
  const weakSpots = QUESTIONS.filter((q) => answers[q.key] === 0).map((q) => q.area);
  return { total, stage, weakSpots };
}
